import styled from "styled-components"

import foodIcon from "../../../../assets/MayoClinicInfo/Food.svg"
import mapIcon from "../../../../assets/MayoClinicInfo/Map.svg"


function Place({icon, text, linkText, link}) {
  return (
    <PlaceContainer>
      <Icon 
        src={icon}
      />
      <Text>{text}</Text>
      <LinkText
        href={link}
        target="_blank"
      >{linkText}</LinkText>
    </PlaceContainer>
  )
}

export default function MayoGetAround({style}) {
  return (
    <Container style={style}>
      <Title>
        Get around
      </Title>

      <PlacesList>
        <Place 
          icon={mapIcon}
          text={"Clinic map"}
          linkText={"Download"}
          link={"https://mcforms.mayo.edu/mc1600-mc1699/mc1663-55.pdf"}
        />
        <Place 
          icon={foodIcon}
          text={"Places to eat"}
          linkText={"Link"}
          link={"https://www.mayoclinic.org/patient-visitor-guide/minnesota/places-to-eat"}
        />
      </PlacesList>
    </Container>
  )
}

const Container = styled.div`
  margin-left: 23px;
`

const PlacesList = styled.div`
  display: flex;
  gap: 35px;
`

const PlaceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`


const Title = styled.p`
  margin: 0;
  font-size: 24px;
  color: #1A1A1A;
  margin-bottom: 24px;
`

const Icon = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
`

const Text = styled.p`
  margin: 0;
  font-size: 17px;
  color: #1A1A1A;
`

const LinkText = styled.a`
  margin: 0;
  font-size: 17px;
  color: #83A4FC;
  text-decoration: underline;
`